import * as React from "react";
import { PureComponent } from "react";
import { connect } from "react-redux";
import { WithStyles, withStyles, Theme, createStyles } from "@material-ui/core";
import VideoList from "src/common/Components/HelpVideos/VideoList";
import { StoreState } from "src/external/store/storeState";
import { CustomerState } from "src/external/types/authentication";
import Video from "src/common/Components/HelpVideos/Video";
import withWidth, { isWidthUp, WithWidth } from "@material-ui/core/withWidth";
import { Switch, Route, RouteComponentProps, withRouter } from "react-router-dom";
import { VideoResponse } from "src/common/types/videos";

interface VideosMasterDetailReduxProps {
  auth: CustomerState;
  videoRes: VideoResponse;
}

interface VideosMasterDetailProps
  extends VideosMasterDetailReduxProps,
    WithWidth,
    WithStyles<typeof styles>,
    RouteComponentProps<any> {}

interface VideosMasterDetailState {}

class VideosMasterDetail extends PureComponent<VideosMasterDetailProps, VideosMasterDetailState> {
  render() {
    const { classes, width, videoRes } = this.props;
    return (
      <div className={classes.root}>
        {isWidthUp("md", width) ? (
          <>
            <div className={classes.videoListContainer}>
              <VideoList path={videoRes.path} videoTitles={videoRes.videoTitles} />
            </div>
            <div className={classes.videoContainer}>
              <Route
                key={this.props.location.pathname}
                exact={true}
                path="/help/:videos/:folder/:title"
                component={Video}
              />
            </div>
          </>
        ) : (
          <Switch>
            <Route key="help" exact={true} path="/help">
              <div className={classes.videoListContainer}>
                <VideoList path={videoRes.path} videoTitles={videoRes.videoTitles} />
              </div>
            </Route>
            <div className={classes.mobileVideoContainer}>
              <Route
                key={this.props.location.pathname}
                exact={true}
                path="/help/:videos/:folder/:title"
                component={Video}
              />
            </div>
          </Switch>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state: StoreState): VideosMasterDetailReduxProps => {
  return {
    auth: state.authentication,
    videoRes: state.videos
  };
};
const IE = window.navigator.userAgent.indexOf("Trident/") > 0;
let minWidthSetting = IE ? "20rem" : "30rem";
let maxWidthSetting = IE ? "30rem" : "40rem";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      width: "100%",
      height: "100%"
    },
    videoListContainer: {
      flex: 1,
      minWidth: minWidthSetting,
      maxWidth: maxWidthSetting
    },
    videoContainer: {
      height: "100%",
      flex: 3,
      overflow: "hidden"
    },
    mobileVideoContainer: {
      display: "flex",
      justifyContent: "center",
      overflow: "hidden"
    }
  });

const connected = connect(mapStateToProps)(withStyles(styles)(withRouter(VideosMasterDetail)));
export default withWidth()(connected as any);
